import { IconTooltip } from 'utils/components/IconTooltip';
import React from 'react';
import { useWidgetContext } from 'widgets/WidgetContext';
import { WidgetType } from 'widgets/WidgetType';

export default function PredictedVolumeCapsuleHelp() {
    const { widgetType } = useWidgetContext();

    return widgetType === WidgetType.PREDICTED_VOLUME_CAPSULE ? (
        <PredictedRemainingVolumeChartHelp />
    ) : (
        <PredictedCloseVolumeChartHelp />
    );
}

function PredictedCloseVolumeChartHelp() {
    return (
        <IconTooltip>
            <div>
                The Predicted Close Volume Capsule displays the % that my order
                leaves account for in the predicted market close auction.
                <br />
                <br />
                The yellow segment indicates the predicted market close auction
                volume. The overlaid blue/red (for buys/sells) segment shows the
                selected order(s) leaves.
                <br />
                <br />
                This capsule requires a selected order and therefore does not
                participate in a pinned capsule container.
            </div>
        </IconTooltip>
    );
}

function PredictedRemainingVolumeChartHelp() {
    return (
        <IconTooltip>
            <div>
                The Predicted Remaining Volume Capsule displays the % that my
                order leaves account for in the predicted market volume from
                now.
                <br />
                <br />
                The yellow segment indicates the predicted market close auction
                volumes. The white segment shows the predicted continuous
                trading volume. The overlaid blue/red (for buys/sells) segment
                shows the selected order(s) leaves.
                <br />
                <br />
                This capsule requires a selected order and therefore does not
                participate in a pinned capsule container.
            </div>
        </IconTooltip>
    );
}
